var render, staticRenderFns
import script from "./EzTabs.vue?vue&type=script&lang=js&"
export * from "./EzTabs.vue?vue&type=script&lang=js&"
import style0 from "./EzTabs.vue?vue&type=style&index=0&id=1d5d2304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d2304",
  null
  
)

export default component.exports